export * from "./firebase.config";

export const taxCountryCode = "CA";

export const googleReviewsPlaceId = "ChIJ_-oH7vFjcVMRqdMEWuwZoDw";

export const googleReviewsKey = "AIzaSyC1KwX21nTfrFaqBikz6Sx2wuG8twu_ExA";
